(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("everywhen", [], factory);
	else if(typeof exports === 'object')
		exports["everywhen"] = factory();
	else
		root["everywhen"] = factory();
})(self, () => {
return 